import { RefereeLicensesListTable } from './components/referee-licenses-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { useAuthentication } from '~/hooks/useAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useRefereeLicensesListQuery } from '../queries';
import { Button } from '~/components/Button/Button';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';

export const Page = withPrivateRoute(() => {
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);
  const { data, isLoading } = useRefereeLicensesListQuery({ judge: id });
  const { can } = useAuthentication();

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Licenser" />

        {can('create-referee-license') && (
          <Button type="button" onClick={() => navigate('create')}>
            Ansök om licens
          </Button>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <RefereeLicensesListTable licenses={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
});
